import { render, staticRenderFns } from "./ApmsRegCanteenRequisitionDetail.vue?vue&type=template&id=289cc6b2&scoped=true&"
import script from "./ApmsRegCanteenRequisitionDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegCanteenRequisitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289cc6b2",
  null
  
)

export default component.exports